import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fullLoading: false,
  error: null,
};

export const appslice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.fullLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loadingStart, loadingStop } = appslice.actions;

export default appslice.reducer;
